import React, { createContext, useState, useContext } from 'react';
import {Routes} from "react-router-dom";
import AuthProvider from '../contexts/auth'
import SignRoutes from './SignRoutes';
import DefaultRoutes from './DefaultRoutes';

export default function IndexRoutes(){
    const auth = useContext(AuthProvider);
    return (
        auth.signed ? <DefaultRoutes /> : <SignRoutes />
    );
};
